/*
 * Title: Rewards/Tabshead.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Page title and Filter shows on desktop.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";

type Props = {};

const TabsHead: React.FC<Props> = (props) => {
  return (
    <div className="items-center justify-between hidden lg:flex">
      {/* my rewards desktop tab header starts  */}
      {/* <h4 className="font-normal text-primary text-[24px] tracking-wider">
        My Rewards..
      </h4> */}
      {/* my rewards desktop filters slide from right  */}
      {/* my rewards tab header end  */}
    </div>
  );
};

export default TabsHead;
